"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var XMLSerializer = exports.XMLSerializer = window.XMLSerializer;


//////////////////
// WEBPACK FOOTER
// ./~/jsonld-rdfa-parser/dist/browser/xmldom.js
// module id = 269
// module chunks = 0